import { httpGet, httpDelete, httpPost, httpPut } from "./AbstractService";
import ENDPOINTS from "../data/endpoints.json";
import Chip from "@mui/material/Chip";
import { COMM_SERVICE_YEAR } from "../constants/commService";

export const saveCommServiceType = (
  school,
  jwt,
  eid,
  name,
  description,
  showToStudent
) => {
  const values = {
    name,
    description,
    showToStudent,
  };

  if (eid == null) {
    return httpPost(
      jwt,
      `${ENDPOINTS[school.region].cs}/comm-service-type`,
      values
    );
  } else {
    return httpPut(
      jwt,
      `${ENDPOINTS[school.region].cs}/comm-service-type/${eid}`,
      values
    );
  }
};

export const deleteCommServiceType = (school, jwt, eid) => {
  return httpDelete(
    jwt,
    `${ENDPOINTS[school.region].cs}/comm-service-type/${eid}`
  );
};

export const getCommServiceTypes = (school, jwt) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].cs}/comm-service-type`);
};

export const saveCommService = (
  school,
  jwt,
  serviceTypeEid,
  dateStart,
  dateEnd,
  description,
  hours,
  minutes,
  verifyWith,
  verifierEmail,
  originalFilename,
  savedFilename,
  fileSize,
  contentType,
  shaCode,
  studentEids = null
) => {
  const values = {
    serviceTypeEid,
    dateStart,
    dateEnd,
    description,
    hours,
    minutes,
    savedFilename,
    originalFilename,
    fileSize,
    contentType,
    verifyWith,
    verifierEmail,
    shaCode,
    studentEids,
  };
  console.log(values);

  return httpPost(
    jwt,
    `${ENDPOINTS[school.region].cs}/comm-service/add`,
    values
  );
};

export const getPresignedCommServiceUrl = (school, jwt, filename) => {
  const values = {
    filename,
  };
  return httpPost(
    jwt,
    `${ENDPOINTS[school.region].cs}/comm-service/file/url`,
    values
  );
};

export const getStudentCommServices = (school, jwt) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].cs}/comm-service/student`);
};

export const getSchoolPendingServices = (school, jwt, grade) => {
  return httpGet(
    jwt,
    `${ENDPOINTS[school.region].cs}/comm-service/school?status=0&grade=${grade}`
  );
};

export const getPendingGradeCounts = (school, jwt) => {
  return httpGet(
    jwt,
    `${ENDPOINTS[school.region].cs}/comm-service/grade?status=0`
  );
};

export const getCommServiceStatusText = (status) => {
  switch (status) {
    case 50:
      return <Chip label="CREATED BY TEACHER" />;
    case 100:
      return <Chip label="APPROVED" color="success" />;
    case -100:
      return <Chip label="REJECTED" color="error" />;
    default:
      return <Chip label="PENDING" color="warning" />;
  }
};

export const getCommServiceStatusChip = (status) => {
  switch (status) {
    case 50:
      return <Chip label="CREATED BY TEACHER" color="primary" />;
    case 100:
      return <Chip label="APPROVED" color="success" />;
    case -100:
      return <Chip label="REJECTED" color="error" />;
    default:
      return <Chip label="PENDING APPROVAL" color="warning" />;
  }
};

export const deleteCommService = (school, jwt, eid) => {
  return httpDelete(
    jwt,
    `${ENDPOINTS[school.region].cs}/comm-service/entry/${eid}`
  );
};

export const adminApproveCommService = (
  school,
  jwt,
  eid,
  hourNum,
  minuteNum
) => {
  return httpPut(
    jwt,
    `${ENDPOINTS[school.region].cs}/comm-service/entry/${eid}`,
    {
      status: 100,
      hourNum,
      minuteNum,
    }
  );
};
export const adminRejectCommService = (
  school,
  jwt,
  eid,
  reason,
  hourNum,
  minuteNum
) => {
  return httpPut(
    jwt,
    `${ENDPOINTS[school.region].cs}/comm-service/entry/${eid}`,
    {
      status: -100,
      reason,
      hourNum,
      minuteNum,
    }
  );
};

export const adminGetCommServiceDownloadUrl = (school, jwt, eid) => {
  return httpGet(
    jwt,
    `${ENDPOINTS[school.region].cs}/comm-service/entry/${eid}/url`
  );
};

export const downloadFile = async (filename, url) => {
  let link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.target = "_blank";
  link.click();
  URL.revokeObjectURL(link.href);
};

export const adminGetCommServiceHistory = (
  school,
  jwt,
  dateStart,
  dateEnd,
  studentEid,
  studentListEid
) => {
  let url = `${
    ENDPOINTS[school.region].cs
  }/comm-service/history?dateStart=${dateStart}&dateEnd=${dateEnd}`;

  if (studentEid != null) {
    url += `&studentEid=${studentEid}`;
  } else {
    url += `&studentListEid=${studentListEid}`;
  }

  return httpGet(jwt, url);
};

export const adminGetCommServiceTotals = (
  school,
  jwt,
  dateStart,
  dateEnd,
  studentListEid,
  show,
  comparator,
  hours
) => {
  let url = `${
    ENDPOINTS[school.region].cs
  }/comm-service/totals?dateStart=${dateStart}&dateEnd=${dateEnd}&show=${show}&comparator=${comparator}&hours=${hours}&studentListEid=${studentListEid}`;
  return httpGet(jwt, url);
};

export const extGetCommServiceOp = (school, eid) => {
  let url = `${
    ENDPOINTS[school.region].cs
  }/comm-service/service/ext?eid=${eid}`;
  return httpGet(null, url);
};

export const extUpdateCommServiceOp = (school, eid, status, rejectReason) => {
  let url = `${
    ENDPOINTS[school.region].cs
  }/comm-service/service/ext?eid=${eid}`;
  return httpPut(null, url, { status, rejectReason });
};

export const transferCommServiceOp = (
  school,
  jwt,
  serviceOpEid,
  newTeacherEid
) => {
  let url = `${
    ENDPOINTS[school.region].cs
  }/comm-service/entry/${serviceOpEid}/transfer`;
  return httpPut(jwt, url, { teacherEid: newTeacherEid });
};

export const getActivityDateCommServices = (school, jwt, activityDateEid) => {
  let url = `${
    ENDPOINTS[school.region].cs
  }/comm-service/activity-date/${activityDateEid}`;

  return httpGet(jwt, url);
};

export const teacherAddCommService = (
  school,
  jwt,
  serviceTypeEid,
  activityDateEid,
  description,
  studentOps
) => {
  const values = {
    serviceTypeEid,
    activityDateEid,
    description,
    studentOps,
  };

  return httpPost(
    jwt,
    `${
      ENDPOINTS[school.region].cs
    }/comm-service/activity-date/${activityDateEid}`,
    values
  );
};

export const getStudentStatusTotals = (school, jwt, studentEid) => {
  let url = `${
    ENDPOINTS[school.region].cs
  }/comm-service/student/${studentEid}/total`;

  return httpGet(jwt, url);
};

export const addCommServiceReviewer = (school, jwt, teacherEids) => {
  const values = {
    teacherEids,
  };

  return httpPost(
    jwt,
    `${ENDPOINTS[school.region].cs}/comm-service-reviewer`,
    values
  );
};

export const getCommServiceReviewers = (school, jwt) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].cs}/comm-service-reviewer`);
};

export const removeCommServiceReviewer = (school, jwt, reviewerEid) => {
  return httpPut(jwt, `${ENDPOINTS[school.region].cs}/comm-service-reviewer`, {
    reviewerEid,
  });
};

export const getStudentsWithoutGoalsCount = (school, jwt) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].cs
    }/comm-service/students-no-goals?count=true&year=${COMM_SERVICE_YEAR}`
  );
};

export const getStudentsWithoutGoals = (school, jwt, year) => {
  return httpGet(
    jwt,
    `${
      ENDPOINTS[school.region].cs
    }/comm-service/students-no-goals?count=false&year=${year}`
  );
};

export const assignStudentGoal = (school, jwt, studentEid, year, value) => {
  return httpPost(jwt, `${ENDPOINTS[school.region].cs}/comm-service/goal/add`, {
    studentEid,
    year,
    value,
  });
};

export const getCommServiceOrgs = (school, jwt) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].cs}/comm-service-org`);
};

export const addCommServiceOrg = (
  school,
  jwt,
  name,
  description,
  url,
  emailDomain
) => {
  const values = {
    name,
    description,
    url,
    emailDomain,
  };

  return httpPost(
    jwt,
    `${ENDPOINTS[school.region].cs}/comm-service-org`,
    values
  );
};

export const removeCommServiceOrg = (school, jwt, orgEid) => {
  return httpPut(jwt, `${ENDPOINTS[school.region].cs}/comm-service-org`, {
    orgEid,
  });
};

export const getRestrictedEmails = (school, jwt) => {
  return httpGet(
    jwt,
    `${ENDPOINTS[school.region].cs}/comm-service-restricted-email`
  );
};

export const addCommServiceRestrictedEmail = (school, jwt, emailDomain) => {
  const values = {
    emailDomain,
  };

  return httpPost(
    jwt,
    `${ENDPOINTS[school.region].cs}/comm-service-restricted-email`,
    values
  );
};

export const removeCommServiceRestrictedEmail = (school, jwt, reEid) => {
  return httpPut(
    jwt,
    `${ENDPOINTS[school.region].cs}/comm-service-restricted-email`,
    {
      reEid,
    }
  );
};

export const adminGetCommServiceOpsByStatus = (
  school,
  jwt,
  dateStart,
  dateEnd,
  status,
  deleted
) => {
  let url = `${
    ENDPOINTS[school.region].cs
  }/comm-service/ops-by-status?dateStart=${dateStart}&dateEnd=${dateEnd}&status=${status}&deleted=${deleted}`;

  return httpGet(jwt, url);
};

export const getCommServiceComments = (school, jwt, opEid) => {
  return httpGet(
    jwt,
    `${ENDPOINTS[school.region].cs}/comm-service-comment?eid=${opEid}`
  );
};

export const commentCommServiceOp = (school, jwt, opEid, comment) => {
  const values = {
    opEid,
    comment,
  };

  return httpPost(
    jwt,
    `${ENDPOINTS[school.region].cs}/comm-service-comment`,
    values
  );
};

export const removeCommServices = (school, jwt, opEids) => {
  return httpPut(jwt, `${ENDPOINTS[school.region].cs}/comm-service/remove`, {
    opEids,
  });
};

export const removeCommServiceComment = (school, jwt, commentEid) => {
  return httpPut(jwt, `${ENDPOINTS[school.region].cs}/comm-service-comment`, {
    commentEid,
  });
};

export const sendStudentReminder = (school, jwt, eid) => {
  return httpPut(
    jwt,
    `${ENDPOINTS[school.region].cs}/comm-service/entry/${eid}/reminder`,
    {}
  );
};

export const getCommServiceReminders = (school, jwt, eid) => {
  return httpGet(
    jwt,
    `${ENDPOINTS[school.region].cs}/comm-service/entry/${eid}/reminder`
  );
};

export const getCommServiceSubmissionRanges = (school, jwt) => {
  return httpGet(
    jwt,
    `${ENDPOINTS[school.region].cs}/comm-service-submission-range`
  );
};

export const adminGetCommServiceSubmissionRanges = (school, jwt) => {
  return httpGet(
    jwt,
    `${ENDPOINTS[school.region].cs}/adm/comm-service-submission-range`
  );
};

export const addSubmissionDateRange = (school, jwt, dateStart, dateEnd, dateDeadline, enabled) => {
  const values = {
    dateStart, dateEnd, dateDeadline, enabled
  };

  return httpPost(
    jwt,
    `${ENDPOINTS[school.region].cs}/adm/comm-service-submission-range`,
    values
  );
};

export const removeSubmissionDateRange = (school, jwt, eid) => {
  return httpPut(
    jwt,
    `${ENDPOINTS[school.region].cs}/adm/comm-service-submission-range`,
    {
      eid,
    }
  );
};

export const updateCommServiceAttribute = (school, jwt, eid, type, value) => {
  return httpPut(
    jwt,
    `${ENDPOINTS[school.region].cs}/comm-service/entry/${eid}/update`,
    {
      type, value
    }
  );
};

export const getCommServiceFiscalYears = (school, jwt) => {
  return httpGet(jwt, `${ENDPOINTS[school.region].cs}/comm-service-fiscal-year`);
};

export const addFiscalYear = (school, jwt, name, dateStart, dateEnd) => {
  const values = {
    name, dateStart, dateEnd
  };

  return httpPost(
    jwt,
    `${ENDPOINTS[school.region].cs}/comm-service-fiscal-year`,
    values
  );
};

export const removeFiscalYear = (school, jwt, eid) => {
  return httpPut(
    jwt,
    `${ENDPOINTS[school.region].cs}/comm-service-fiscal-year`,
    {
      eid,
    }
  );
};

